import {
  CognitoUser, CognitoUserPool, AuthenticationDetails, CookieStorage,
} from 'amazon-cognito-identity-js'

const userPool = new CognitoUserPool({
  UserPoolId: USER_POOL_ID,
  ClientId: USER_POOL_CLIENT_ID,
  Storage: new CookieStorage({ domain: window.location.hostname, secure: window.location.hostname !== 'localhost' }),
})

export const sendSetPasswordRequest = (...props) => {
  const [
    username,
    confirmationCode,
    newPassword,
    onSuccess,
    onFail,
  ] = props

  const userData = {
    Username: username,
    Pool: userPool,
    Storage: new CookieStorage({ domain: window.location.hostname, secure: window.location.hostname !== 'localhost' }),
  }

  const cognitoUser = new CognitoUser(userData)

  cognitoUser.confirmPassword(confirmationCode, newPassword, {
    onSuccess() {
      onSuccess()
    },
    onFailure(err) {
      onFail(err)
    },
  })
}

export const cognitoSignIn = ({
  username, password, getCurrentUser, changePasswordRequired, fail, props,
}) => {
  const authenticationData = {
    Username: username,
    Password: password,
  }

  const authenticationDetails = new AuthenticationDetails(authenticationData)

  const userData = {
    Username: username,
    Pool: userPool,
    Storage: new CookieStorage({ domain: window.location.hostname, secure: window.location.hostname !== 'localhost' }),
  }

  const cognitoUser = new CognitoUser(userData)

  cognitoUser.authenticateUser(authenticationDetails, {
    onSuccess(result) {
      getCurrentUser(props)
    },
    onFailure(err) {
      fail(err)
    },
    newPasswordRequired() {
      changePasswordRequired(username, props)
    }
  })
}

export const changePassword = (username, oldPassword, newPassword, onSuccess, onFailure) => {
  const authenticationData = {
    Username: username,
    Password: oldPassword,
  }

  const authenticationDetails = new AuthenticationDetails(authenticationData)

  const userData = {
    Username: username,
    Pool: userPool,
    Storage: new CookieStorage({ domain: window.location.hostname, secure: window.location.hostname !== 'localhost' }),
  }

  const cognitoUser = new CognitoUser(userData)

  cognitoUser.authenticateUser(authenticationDetails, {
    onSuccess() {
      cognitoUser.changePassword(oldPassword, newPassword, (err) => {
        if (err) {
          onFailure(err)
        } else {
          onSuccess()
        }
      })
    },
    onFailure,
    newPasswordRequired: () => {
      cognitoUser.completeNewPasswordChallenge(newPassword, null, { onSuccess, onFailure })
    }
  })
}

export const forgotPassword = (username, onSuccess, onFailure) => {
  const userData = {
    Username: username,
    Pool: userPool,
    Storage: new CookieStorage({ domain: window.location.hostname, secure: window.location.hostname !== 'localhost' }),
  }

  const cognitoUser = new CognitoUser(userData)
  cognitoUser.forgotPassword({
    onSuccess,
    onFailure
  })
}

export const cognitoSignOut = () => {
  const cognitoUser = userPool.getCurrentUser()
  cognitoUser && cognitoUser.signOut()
}

export const checkCognitoSession = () => {
  const cognitoUser = userPool.getCurrentUser()
  if (!cognitoUser) return null
  const currentSession = cognitoUser.getSession((err, cachedSession) => (err ? null : cachedSession))
  if (!currentSession) return null
  return currentSession.isValid()
    ? currentSession
    : cognitoUser.refreshSession(currentSession.getRefreshToken(),
      (err, newSession) => (err ? null : newSession))
}

export default {
  service: {
    sendSetPasswordRequest,
    cognitoSignIn,
    checkCognitoSession,
    cognitoSignOut,
  },
}
